import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { ReactComponent as LogoEme } from "../img/LogoEME.svg";
import '../css/MainHeader.css';

const Layout = () => { 
  const [headerLinksColor, setHeaderLinksColor] = useState('#fff');
  const location = useLocation();

  useEffect(() => {
    // Si estás en la raíz es blanco, si estás en proyectos, servicios o contacto es negro
    if (location.pathname === '/') {
      setHeaderLinksColor('#fff');
    } else if (['/projects', '/services', '/contacto'].includes(location.pathname)) {
      setHeaderLinksColor('#000');
    }
  }, [location.pathname]);

  return (
    <div className="mainPage">
      <div className="page__header">
        
        {/* 🔹 Logo */}
        <Link to="/" style={{ height: '100%', display: 'inline-block' }}>
          <div className='logoEme' style={{ cursor: 'pointer', height: '100%' }}>
            <LogoEme
              role="img"
              aria-label="Logo Eme"
              style={{ fill: headerLinksColor, height: '100%' }}
            />
          </div>
        </Link>

        {/* 🔹 Enlaces con el color dinámico */}
        <ul className="section__links">
          <Link to={"/projects"} style={{ color: headerLinksColor }}><li>Proyectos</li></Link>
          <Link to={"/services"} style={{ color: headerLinksColor }}><li>Servicios</li></Link>
          <Link to={"/contacto"} style={{ color: headerLinksColor }}><li>Contacto</li></Link>
        </ul> 
      </div>

      <div className="page__content">
        <Outlet context={{ setHeaderLinksColor }} />
      </div>
    </div>
  );
};

export default Layout;